<textarea #textarea pInputTextarea [(ngModel)]="value" [rows]="rows" [cols]="cols" [placeholder]="placeholder"
  [required]="required" (input)="onValueChange($event)" (focus)="onFocus()" (blur)="onBlur()">
</textarea>
@if (touched && isRequiredAndEmpty) {
  <p class="text-danger">{{ errorMessage }}</p>
}